<template>
    <div class="component component__filtersdashboardreports">
        <component-wrapper :overlay="true">
            <template v-if="requestPending">
                <component-loading :size="'small'"></component-loading>
            </template>
            <template v-else>
                <div class="container">
                    <div class="columns is-block-mobile columns--margin-1-mobile is-centered is-vcentered is-variable is-6">
                        <div class="column is-narrow">
                            <component-title :raw="true" :size="'small'">Filters:</component-title>
                        </div>
                        <div class="column">
                            <div class="columns is-block-mobile is-vcentered is-variable is-4">
                                <template v-for="(item, index) in selectItems">
                                    <div class="column custom--block is-narrow" :key="index">
                                        <filter-select
                                            :select-item="item"
                                            @emit-filter="handleFiltersSelect"
                                        />
                                    </div>
                                </template>
                                <div class="column"></div>
                                <template v-if="searchActive">
                                    <div class="column is-narrow">
                                        <filter-search
                                            :value="searchValue"
                                            :search-placeholder="'Search'"
                                            @emit-input="emitSearch"
                                        ></filter-search>
                                    </div>
                                </template>
                                <div class="column is-narrow">
                                    <component-button
                                        :align="'left'"
                                        :name="'base-filter-select-button'"
                                        :animate-loading="true"
                                        :animate-loading-force="requestPending"
                                        :animate-loading-event-name="'component-filters-dashboard-reports-submit'"
                                        @click="handleFiltersSelectSubmit"
                                    >Apply
                                    </component-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </component-wrapper>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import FilterSelect from '@/components/default/filters/FilterSelect'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import FilterSearch from '@/components/default/filters/FilterSearch'

export default {
  name: 'component-filters-dashboard-reports',
  components: {
    FilterSearch,
    ComponentLoading,
    FilterSelect,
    ComponentTitle,
    ComponentButton,
    ComponentWrapper
  },
  data () {
    return {
      requestPending: false
    }
  },
  props: {
    filterKey: {
      type: String
    },
    searchActive: {
      type: Boolean,
      default: false
    },
    searchValue: {
      type: String
    }
  },
  computed: {
    selectItems () {
      const selectedValues = this.filtersSelected
      const selectedDates = selectedValues.length && selectedValues.find(obj => obj.key === 'dates') ? selectedValues.find(obj => obj.key === 'dates').values : []
      const selectedOrgUnits = selectedValues.length && selectedValues.find(obj => obj.key === 'orgUnits') ? selectedValues.find(obj => obj.key === 'orgUnits').values : []
      const selectedGroups = selectedValues.length && selectedValues.find(obj => obj.key === 'groups') ? selectedValues.find(obj => obj.key === 'groups').values : []

      return [
        {
          key: 'dates',
          label: 'Enrolment dates range',
          type: 'date',
          preselected: selectedDates,
          rangeOnly: this.filterKey === 'learning_activity',
          rangeActive: true,
          rangeItems: [
            {
              label: 'Last 7 days',
              value: 'last-7-days'
            },
            {
              label: 'Last 30 days',
              value: 'last-30-days'
            },
            {
              label: 'Last 12 months',
              value: 'last-12-months'
            }
          ],
          preventClear: true
        },
        {
          key: 'orgUnits',
          label: 'Organisation unit',
          type: 'org-units',
          preselected: selectedOrgUnits
        },
        {
          key: 'groups',
          label: 'Group',
          type: 'multiselect',
          preselected: selectedGroups,
          getItemsGetter: 'getLmsSuperadminGroupsMappedIdName',
          getItemsGetterMapped: 'getLmsSuperadminGroupsMappedLabelValue',
          getItemsDispatch: 'lmsSuperadminGroupsGet',
          itemName: ['group', 'groups'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        }
      ]
    },
    filtersSelected () {
      return this.$store.getters.getEbsReportDashboardFiltersTemporary(this.filterKey)
    }
  },
  methods: {
    emitSubmitRequest () {
      this.$emit('emit-submit-request')
    },
    emitGetRequest () {
      this.$emit('emit-get-request')
    },
    emitSearch (data) {
      this.$emit('emit-search', data)
    },
    handleFiltersSelect (data) {
      const filterKey = this.filterKey
      const type = 'temporary'
      this.$store.dispatch('ebsReportDashboardSetFilters', { data, filterKey, type })
    },
    handleFiltersSelectSubmit () {
      const filterKey = this.filterKey
      this.requestPending = true
      this.$store.dispatch('ebsReportDashboardUpdateFilters', { filterKey }).finally(() => {
        this.emitSubmitRequest()
        this.requestPending = false
        this.$eventBus.$emit('stop-component-filters-dashboard-reports-submit')
      })
    },
    getReportDashboardFilters () {
      const filterKey = this.filterKey
      this.requestPending = true
      this.$store.dispatch('ebsReportDashboardGetFilters', filterKey).finally(() => {
        this.requestPending = false
        this.emitGetRequest()
      })
    }
  },
  created () {
    this.getReportDashboardFilters()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentfiltersdashboardreports";
</style>
